import { useTranslation } from 'react-i18next';

import useMe from 'app/common/hooks/queries/useMeUncamel';
import { STATIC_COMMON_ASSETS_DIR } from 'app/config';

import { PARTOOROBOT_SIDEBAR_LOGO } from 'app/constants/robot';

import { useIsDarkTheme } from 'app/Theme';

import { ProviderLogoLinkWithInnerSvg, ProviderLogoWithBackground } from './SidebarLogo.styled';

export const SidebarLogo = () => {
    const { t } = useTranslation();
    const { data: me } = useMe();
    const isDarkMode = useIsDarkTheme();
    const logoSrc = `${STATIC_COMMON_ASSETS_DIR}/logos/partoo/partoo_logo_${isDarkMode ? 'dark' : 'light'}.svg`;

    if (!me?.provider_logo) {
        return (
            <ProviderLogoLinkWithInnerSvg to="/" data-partoorobot={PARTOOROBOT_SIDEBAR_LOGO}>
                <img src={logoSrc} alt={t('partoo_logo')} />
            </ProviderLogoLinkWithInnerSvg>
        );
    }
    return (
        <ProviderLogoWithBackground>
            <ProviderLogoLinkWithInnerSvg
                to="/"
                data-partoorobot={PARTOOROBOT_SIDEBAR_LOGO}
                {...{
                    dangerouslySetInnerHTML: {
                        __html: me.provider_logo,
                    },
                }}
            />
        </ProviderLogoWithBackground>
    );
};
